module.exports = __webpack_public_path__ + "img/complete_bg.d2fc4854.png";